import { DateTime } from 'luxon';
import { generatePath, useParams } from 'react-router-dom';
import { hqRoutes } from 'hq/Routes';
import { useHqRelativePath } from 'hq/hooks/useHqRelativePath';
import { paths as ogpPaths } from 'ogp/paths';
import { routePrefix as ogpRoutePrefix } from 'ogp/settings';
import { PARTNER_PATHS } from 'partner/paths';
import { partnerRoutePrefix } from 'partner/settings';
import { useSiteDetection } from 'shared/hooks';
import { getQueryParameters } from 'shared/hooks/query-hooks/relative-path-utils';
import { assertUnreachable } from '@levelworks/shared-utils-ts';

export const useGetShiftPlanningUrl = () => {
  const { site } = useSiteDetection();
  const { companyHash, partnerHash } = useParams();
  const generateHqPath = useHqRelativePath();

  return (shiftId: string, utcStartDateTime: string): string => {
    const shiftDate = DateTime.fromISO(utcStartDateTime).toLocal().toISODate() ?? undefined;

    switch (site) {
      case 'hq':
        return generateHqPath(hqRoutes.PlannerShift, undefined, {
          shiftDetailId: shiftId,
          fromDate: shiftDate,
        });
      case 'ogp':
        return (
          generatePath(`${ogpRoutePrefix}/:companyHash/${ogpPaths.ShiftPlanning.path}`, {
            companyHash: companyHash ?? '',
            '*': 'calendar',
          }) + getQueryParameters({ shiftId, date: shiftDate })
        );
      case 'partner':
        return (
          generatePath(`${partnerRoutePrefix}/:partnerHash/${PARTNER_PATHS.ShiftsPlanning.path}`, {
            partnerHash: partnerHash ?? '',
          }) + getQueryParameters({ shiftId })
        );
      default:
        assertUnreachable(site);
    }
  };
};
